var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.opened)?_c('div',{staticClass:"black-overlay",on:{"click":_vm.hide}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }